export type FileDownloadSource = string | Blob | undefined;

export const FILE_DOWNLOAD_ERROR = 'Source or filename empty.';

export interface TransientBlobUrl {
  url: string;
  cleanup: () => void;
}
